














































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Comune } from '@/data/models/comune.model';
import { Search } from '@/data/models/search.model';
import { ClassType } from 'class-transformer/ClassTransformer';
import store, { State } from '@/store';
import { ShipmentStatus } from '@/data/models/offer.model';
import { Contatto } from '@/data/models/contatto.model';
import { date2Num, dateEndofDay, newDate } from '@/data/utils/helper';
import { User, UserType } from '@/data/models/user.model';

@Component
export default class RiscossioneFilter extends Vue {

	advancedSearch: Search;

	searchParam: any = new class {
		createdates?: Date[] = [];
		deliverydates?: Date[] = [];
		statuses?: ShipmentStatus[] = [
			ShipmentStatus.TO_BE_ASSIGNED,
			ShipmentStatus.TO_BE_PRINTED
		];
		paymode?: any = null;
		comune?: Comune;
		zipcode?: string = '';
		contatto?: Contatto;
		email?: string = '';
		operatore?: User;
		fattorino?: User;
		mobile?: string;
		nooperatore: boolean = false;
		envelopegenerated: boolean = true;
	};

	comuneClass: ClassType<Comune> = Comune;
	contattoClass: ClassType<Contatto> = Contatto;
	userClass: ClassType<User> = User;
	contattoSearch: Search = new Search('contact');
	fattorinoSearch: Search = new Search('user');
	operatoreSearch: Search = new Search('user');

	state!: State;

	// @ts-ignore
	statusItems: string[] = Object.keys(ShipmentStatus).map((k: string) => ShipmentStatus[k]);

	constructor() {
		super();
		this.state = store;
		this.advancedSearch = new Search('offer join contact on offer.contactid = contact.id left join user as u1 on offer.operatorid = u1.id left join user as u2 on offer.deliveryid = u2.id');
	}

	created() {
		this.initSearch();
	}

	initSearch() {
		this.fattorinoSearch.reset();
		this.fattorinoSearch.addSimpleFilter('hqid', this.state.headquarter!.id);
		this.fattorinoSearch.addSimpleFilter('utype', UserType.FATTORINO);
		this.operatoreSearch.reset();
		this.operatoreSearch.addSimpleFilter('hqid', this.state.headquarter!.id);
		this.operatoreSearch.addSimpleFilter('utype', UserType.CALL_CENTER);
		this.contattoSearch.reset();
		this.contattoSearch.addSimpleFilter('hqid', this.state.headquarter!.id);
		// this.contattoSearch.addSimpleFilter('status', ContattoStatus.ACTIVE);
	}

	search() {
		this.advancedSearch.reset();

		this.advancedSearch.addSimpleFilter('hqid', this.state.headquarter!.id);

		if (this.searchParam.createdates && this.searchParam.createdates.length) {
			const start = this.searchParam.createdates[0] ? date2Num(this.searchParam.createdates[0]) : 0;
			const end = this.searchParam.createdates[1] ? date2Num(dateEndofDay(this.searchParam.createdates[1])) : newDate(true).getTime();
			this.advancedSearch.addRangeFilter('insdate', start as number, end as number);
		}

		if (this.searchParam.deliverydates && this.searchParam.deliverydates.length) {
			const start = this.searchParam.deliverydates[0] ? date2Num(this.searchParam.deliverydates[0]) : 0;
			const end = this.searchParam.deliverydates[1] ? date2Num(dateEndofDay(this.searchParam.deliverydates[1])) : newDate(true).getTime();
			this.advancedSearch.addRangeFilter('deliverydate', start as number, end as number);
		}

		if (this.searchParam.statuses.length) this.advancedSearch.addInFilter('shipmentstatus', this.searchParam.statuses);
		
		if (this.searchParam.paymode) this.advancedSearch.addSimpleFilter('paymode', this.searchParam.paymode);

		if (this.searchParam.comune && this.searchParam.comune.id) this.advancedSearch.addLikeFilter('comune', this.searchParam.comune.descrizione);
		if (this.searchParam.contatto && this.searchParam.contatto.id) this.advancedSearch.addSimpleFilter('contactid', this.searchParam.contatto.id);

		if (this.searchParam.zipcode) this.advancedSearch.addLikeFilter('zipcode', this.searchParam.zipcode);

		if (this.searchParam.email) this.advancedSearch.addLikeFilter('email', this.searchParam.email);
		if (this.searchParam.mobile) this.advancedSearch.addLikeFilter('mobile', this.searchParam.mobile);

		if (this.searchParam.operatore && this.searchParam.operatore.id) this.advancedSearch.addSimpleFilter('operatorid', this.searchParam.operatore.id);
		if (this.searchParam.fattorino && this.searchParam.fattorino.id) this.advancedSearch.addSimpleFilter('deliveryid', this.searchParam.fattorino.id);

		if (this.searchParam.nooperatore) this.advancedSearch.addSimpleFilter('operatorid', null);
		if (this.searchParam.envelopegenerated) this.advancedSearch.addSimpleFilter('envelopegenerated', 0);

		this.$emit('search', {
			search: this.advancedSearch,
			params: this.searchParam,
		});
	}

	reset() {
		this.initSearch();
		this.searchParam.createdates = [];
		this.searchParam.deliverydates = [];
		this.searchParam.statuses = [
			ShipmentStatus.TO_BE_ASSIGNED,
			ShipmentStatus.TO_BE_PRINTED
		];
		this.searchParam.paymode = undefined;
		this.searchParam.comune = {};
		this.searchParam.zipcode = '';
		this.searchParam.contatto = {};
		this.searchParam.email = '';
		this.searchParam.mobile = undefined;
		this.searchParam.contactfullname = undefined;
		this.searchParam.operatore = {};
		this.searchParam.fattorino = {};
		this.searchParam.nooperatore = false;
		this.searchParam.envelopegenerated = true;
		this.search();
	}

	contactFormatter = (contact: Contatto) => {
		if(contact.id) {
			return `${contact.fullname} - ${contact.landline ? contact.landline : contact.mobile}`;
		}
	
	}

}
